module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-data-table', {
    attrs: {
      "headers": _vm.tableHeaders,
      "items": _vm.items,
      "hide-actions": "",
      "loading": _vm.loadingInProgress,
      "no-data-text": _vm.loadingItemsText
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.updated_at))]), _vm._v(" "), _c('td', [_c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "slot": "activator",
            "icon": "",
            "loading": _vm.loading
          },
          on: {
            "click": function($event) {
              return _vm.downloadPDF(props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', {
          attrs: {
            "color": "orange accent-2"
          }
        }, [_vm._v("picture_as_pdf")])], 1), _vm._v("\n          Get PDF invoice\n        ")], 1)], 1)]
      }
    }])
  }), _vm._v(" "), _c('AppMainDialog', {
    attrs: {
      "open": _vm.dialogOpen,
      "message": _vm.dialogMessage,
      "rawHtml": ""
    },
    on: {
      "closedialog": function($event) {
        _vm.dialogOpen = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f653c7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/datatables/CaseFormsAnswersDataTable.vue
// module id = 1004
// module chunks = 1